// extracted by mini-css-extract-plugin
export default {"vote-bump":"style_vote-bump__mc8Dd","voteBump":"style_voteBump__hLwya","vote-button":"style_vote-button__NsOBL"};